export default __webpack_public_path__ + "static/media/fig5.dceb6009.jpg";